import * as React from 'react'
import { NumericInput, Tag } from '@blueprintjs/core'

interface Props {
  onValueChange: (valueAsNumber, valueAsString) => void
  value: string
  rightLabel: string
}

export const DimensionInput: React.FC<Props> = props => {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <NumericInput
          rightElement={<Tag minimal>IN</Tag>}
          buttonPosition="none"
          selectAllOnFocus
          value={props.value}
          onValueChange={props.onValueChange}
          id={`dimension-${props.rightLabel}`}
        />
        <label htmlFor={`dimension-${props.rightLabel}`}>{props.rightLabel}</label>
      </div>
    </>
  )
}
